import React from 'react';
import Txt from '../../../inputs/textInput.js';

const CenterPanelCallerDetail = (props) => {
  return (
    <div className="ui form mrbl pdtsss">
      <div className="title-sms text-size-ml bold mrtxs">{APP.LANGUAGE.SendConsultNowInvitation.Header}</div>
      <div className="title-sms mrtxs">{APP.LANGUAGE.SendConsultNowInvitation.HeaderCaption}</div>
      <div className="title-sms bold mrts mrbxs">{APP.LANGUAGE.SendConsultNowInvitation.FirstName}</div>
      <Txt
        tabIndex="1"
        id="firstName"
        maxLength={32}
        focusme="true"
        titlePlaceholder={APP.LANGUAGE.SendConsultNowInvitation.FirstName}
        placeholder=""
        noTitle
        value={props.formik.values.firstName}
        customOnBlur={true}
        customOnChange={true}
        notRenderPlaceholderAsTitle={true}
        onChange={props.formik.handleChange}
        onBlur={props.formik.handleBlur}
      >
        {props.formik.errors.firstName && (
          <React.Fragment>
            {props.showFirstNameErrorDetail ? (
              <div className="error-label">
                <span className="error-pointy-corner" />
                <span className="error-color">{props.formik.errors.firstName}</span>
              </div>
            ) : (
              ''
            )}
            <i
              className="warning big circle icon error-checkmark"
              onClick={() => props.setShowFirstNameErrorDetail(true)}
            />
          </React.Fragment>
        )}
      </Txt>
      <div className="title-sms bold mrtxs mrbxs">{APP.LANGUAGE.SendConsultNowInvitation.LastName}</div>
      <Txt
        tabIndex="2"
        id="lastName"
        maxLength={32}
        titlePlaceholder={APP.LANGUAGE.SendConsultNowInvitation.LastName}
        placeholder=""
        noTitle
        value={props.formik.values.lastName}
        customOnBlur={true}
        customOnChange={true}
        notRenderPlaceholderAsTitle={true}
        onChange={props.formik.handleChange}
        onBlur={props.formik.handleBlur}
      >
        {props.formik.errors.lastName && (
          <React.Fragment>
            {props.showLastNameErrorDetail ? (
              <div className="error-label">
                <span className="error-pointy-corner" />
                <span className="error-color">{props.formik.errors.lastName}</span>
              </div>
            ) : (
              ''
            )}
            <i
              className="warning big circle icon error-checkmark"
              onClick={() => props.setShowLastNameErrorDetail(true)}
            />
          </React.Fragment>
        )}
      </Txt>
      <div className="mrtl mrbm">
        <div className="title-sms text-size-ml bold mrts mrbxs">{APP.LANGUAGE.SendConsultNowInvitation.Header2}</div>
        <div className="title-sms bold mrts mrbxs">{APP.LANGUAGE.SendConsultNowInvitation.Phone}</div>
        <Txt
          tabIndex="3"
          id="mobile"
          titlePlaceholder={APP.LANGUAGE.SendConsultNowInvitation.Phone}
          placeholder=""
          noTitle
          value={props.formik.values.mobile.trim()}
          customOnBlur={true}
          customOnChange={true}
          notRenderPlaceholderAsTitle={true}
          onChange={props.formik.handleChange}
          onBlur={props.formik.handleBlur}
        >
          {props.formik.errors.mobile && props.formik.touched.mobile && (
            <React.Fragment>
              {props.showMobileErrorDetail ? (
                <div className="error-label">
                  <span className="error-pointy-corner" />
                  <span className="error-color">{props.formik.errors.mobile}</span>
                </div>
              ) : (
                ''
              )}
              <i
                className="warning big circle icon error-checkmark"
                onClick={() => props.setShowMobileErrorDetail(true)}
              />
            </React.Fragment>
          )}
        </Txt>

        <div className="title-sms bold mrts mrbxs">{APP.LANGUAGE.SendConsultNowInvitation.Email}</div>
        <Txt
          tabIndex="4"
          id="email"
          titlePlaceholder={APP.LANGUAGE.SendConsultNowInvitation.Email}
          placeholder=""
          noTitle
          value={props.formik.values.email.trim()}
          customOnBlur={true}
          customOnChange={true}
          notRenderPlaceholderAsTitle={true}
          onChange={props.formik.handleChange}
          onBlur={props.formik.handleBlur}
        >
          {props.formik.errors.email && props.formik.touched.email && (
            <React.Fragment>
              {props.showEmailErrorDetail ? (
                <div className="error-label">
                  <span className="error-pointy-corner" />
                  <span className="error-color">{props.formik.errors.email}</span>
                </div>
              ) : (
                ''
              )}
              <i
                className="warning big circle icon error-checkmark"
                onClick={() => props.setShowEmailErrorDetail(true)}
              />
            </React.Fragment>
          )}
        </Txt>
      </div>
    </div>
  );
};

export default CenterPanelCallerDetail;
